import React, { useEffect, useState } from 'react';
import { UtilityRouteConfig } from './UtilityRouteConfig';
import { createUtilityPath } from '../../../common/utils/api_utils';

export const UtilityConfig = ({ projectId, version, projectDevApis, isReadOnly }) => {
  const [routes, setRoutes] = useState([]);

  useEffect(() => {
    const paths = createUtilityPath(projectDevApis);
    setRoutes(paths);
  }, [projectDevApis]);

  return (
    <div className="app-setting-collection-route-config">
      {routes.map((route) => (
        <UtilityRouteConfig
          route={route}
          projectId={projectId}
          version={version}
          isReadOnly={isReadOnly}
        />
      ))}
    </div>
  );
};
